import { GridSortModel } from "@mui/x-data-grid-pro";
import dayjs, { Dayjs } from "dayjs";
import { createContext, ReactElement, useState } from "react";
import { CoreReturnsFilter } from "../../allCoreReturnsList/reducer/reducer";
import { dayJSFormatterForAPI } from "../../list/reducer/common";

export type AllCoreReturnsContextProps = {
  setAllCoreReturnsContext: (value: AllCoreReturnContextState) => void;
  getAllCoreReturnsContext: () => AllCoreReturnContextState;
};

export type AllCoreReturnContextState = {
  filter: CoreReturnsFilter;
  tabIndex: number;
  pageNumber: number;
  pageSize: number;
  sortModel: GridSortModel;
};

export const AllCoreReturnsContext = createContext(
  {} as AllCoreReturnsContextProps
);

export const AllCoreReturnsProvider = ({
  children,
}: {
  children: ReactElement;
}) => {
  const currentDate: Dayjs = dayjs();
  const [coreReturnsState, setCoreReturnsState] =
    useState<AllCoreReturnContextState>({
      filter: {
        startDate: dayJSFormatterForAPI(currentDate.subtract(1, "year")),
        endDate: dayJSFormatterForAPI(currentDate),
      },
      sortModel: [{ field: "date", sort: "desc" }],
      pageNumber: 0,
      pageSize: 10,
      tabIndex: 0,
    });

  const setAllCoreReturnsContext = (value: AllCoreReturnContextState) => {
    setCoreReturnsState(value);
  };

  const getAllCoreReturnsContext = (): AllCoreReturnContextState =>
    coreReturnsState;

  return (
    <AllCoreReturnsContext.Provider
      value={{
        setAllCoreReturnsContext,
        getAllCoreReturnsContext,
      }}
    >
      {children}
    </AllCoreReturnsContext.Provider>
  );
};
